<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="updateProfile">
          <card v-if="initialized">
            <template slot="header">
              <div style="float: right">
                <h3 class="card-reference">Reference Nr: <b>{{ referenceNr }}</b></h3>
                <base-button type="primary" size="lg" class="btn-fill" v-if="active_tab_id === 'stage-1'" v-on:click="downloadAll">
                  Download all
                </base-button>
                <div v-else class="mb-3 dropdown">
                  <base-button type="primary" size="lg" class="btn-fill text-right" data-toggle="dropdown">
                    Download all
                  </base-button>
                  <ul class="dropdown-menu">
                    <li><a @click="doExport('original')">{{ $t('full_proposal.revision_tab__original_version') }}</a></li>
                    <li><a @click="doExport('revision')" v-if="model.revision && model.revision.revision_id">{{ $t('full_proposal.revision_tab__revised_version') }}</a></li>
                  </ul>
                </div>
              </div>
              <div class="header-title" v-if="active_tab_id === 'stage-1'">
                <h3 class="card-title">{{$t('documents.documents') }}</h3>
                <h2 class="card-title">Concept Note Status :
                  <el-select v-if="loggedUser.role === UserRoles.ADMIN" class="filter-select mr-2 mb-2" v-model="model.application_status" placeholder="Choose application status" @change="changeApplicationStatus">
                    <el-option v-for="item in applicationStatuses" :key="item" :label="item" :value="item"/>
                  </el-select>
                  <span v-if="loggedUser.role !== UserRoles.ADMIN">{{ model.application_status }}</span>
                </h2>
                <p v-if="loggedUser.role === UserRoles.APPLICANT">{{ $t('documents.help') }}</p>
              </div>
              <div class="header-title" v-if="active_tab_id === 'stage-2'">
                <h3 class="card-title">{{$t('documents.documents') }}</h3>
                <h2 class="card-title">{{ $t('stage_two.full_proposal_status') }} :
                  <el-select v-if="loggedUser.role === UserRoles.ADMIN" class="filter-select mr-2 mb-2" v-model="model.stage_two_status" placeholder="Choose application status" @change="changeApplicationStatus">
                    <el-option v-for="item in applicationStatuses" :key="item" :label="item" :value="item"/>
                  </el-select>
                  <span v-if="loggedUser.role !== UserRoles.ADMIN">{{ model.stage_two_status }}</span>
                </h2><br />
                <h2 class="card-title">{{ $t('full_proposal.revision_status') }} :
                  <el-select v-if="loggedUser.role === UserRoles.ADMIN" class="filter-select mr-2 mb-2" v-model="model.revision.status" placeholder="Choose revision status" @change="changeRevisionStatus">
                    <el-option v-for="item in applicationStatuses" :key="item" :label="item" :value="item"/>
                  </el-select>
                  <span v-if="loggedUser.role !== UserRoles.ADMIN">{{ model.revision.status }}</span>
                </h2>
                <p v-if="loggedUser.role === UserRoles.APPLICANT">&nbsp;</p>
              </div>
              <p v-if="loggedUser.role !== UserRoles.APPLICANT">
                Name: {{userDetails.name}}<br/> Email: {{userDetails.email}}<br/> Phone: {{userDetails.phone || '-'}}<br/>
              </p>
            </template>
            <tabs ref="tab-sections" type="info" @activate-tab="activateTab" square>
              <tab-pane id="stage-1" label="Stage 1">
                <el-table class="mt-4" v-if="documents.length" :data="documents">
                  <el-table-column label="type">
                    <template slot-scope="scope">
                      <span v-html="$t(scope.row.name)"></span>
                    </template>
                  </el-table-column>
                  <el-table-column label="filename" property="filename">
                    <div slot-scope="props">
                      <div class="mt-1">
                        <upload-documents-file :is-editable="isEditable && model.application_status === 'DRAFT'" @on-file-update="getItems()" :user-id="loggedUser.id" :file-data="props.row"></upload-documents-file>
                      </div>
                    </div>
                  </el-table-column>
                  <el-table-column label="Uploaded Date" property="created_at" prop="created_at"></el-table-column>
                </el-table>
              </tab-pane>
              <tab-pane id="stage-2" label="Stage 2" v-if="loggedUser.evaluationStatus === 'Preselected' || userDetails.evaluation_status === 'Preselected'">
                <tabs class="versions-tabs" ref="tab-sections" type="info" square>
                  <tab-pane id="original" :label="$t('full_proposal.revision_tab__original_version')">
                    <div class="col-lg-6 mb-4">
                      <h4 class="card-title">{{ $t('stage_two.title') }}</h4>
                      <div class="form-group">
                        <textarea
                          class="form-control"
                          name="evaluation_data.title"
                          v-model="model.evaluation_data.title"
                          :disabled="!isStageTwoEditable"
                          v-validate="'required'"
                          :placeholder="$t('stage_two.title_placeholder')"
                        >
                        </textarea>
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.lead_applicant') }}</h4>
                      <div class="form-group">
                        <textarea
                          class="form-control"
                          name="evaluation_data.lead_applicant_name"
                          v-model="organization"
                          :disabled="!isStageTwoEditable"
                          v-validate="'required'"
                          :placeholder="$t('stage_two.lead_applicant_placeholder')"
                        >
                        </textarea>
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.lead_applicant_type') }}</h4>
                      <div class="form-group">
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.evaluation_data.organization_type.non_governmental_organisation">
                          {{ $t('stage_two.non_governmental_organisation') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.evaluation_data.organization_type.small_socio_professional_organisation">
                          {{ $t('stage_two.small_socio_professional_organisation') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.evaluation_data.organization_type.sub_national_local_authorities_of_ors">
                          {{ $t('stage_two.sub_national_local_authorities_of_ors') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.evaluation_data.organization_type.local_government_departments">
                          {{ $t('stage_two.local_government_departments') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.evaluation_data.organization_type.national_or_local_research_organisation">
                          {{ $t('stage_two.national_or_local_research_organisation') }}
                        </base-checkbox>
                      </div>

                      <div class="mt-3">
                        <h4 class="card-title d-inline-block mr-3">{{ $t('stage_two.co_applicant') }}</h4>
                        <radio name="model.stage_two.has_co_applicant"
                               class="form-check-inline"
                               value="YES"
                               :disabled="!isStageTwoEditable"
                               v-model="model.stage_two.has_co_applicant"
                        >
                          <label>{{ $t('stage_two.general_yes') }}</label>
                        </radio>
                        <radio name="model.stage_two.has_co_applicant"
                               class="form-check-inline"
                               value="NO"
                               :disabled="!isStageTwoEditable"
                               v-model="model.stage_two.has_co_applicant"
                        >
                          <label>{{ $t('stage_two.general_no') }}</label>
                        </radio>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          name="stage_two.name_of_co_applicants"
                          v-model="model.stage_two.name_of_co_applicants"
                          :disabled="model.stage_two.has_co_applicant === 'NO' || !isStageTwoEditable"
                          v-validate="'required'"
                          :placeholder="$t('stage_two.co_applicant_placeholder')"
                        />
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.start_date') }}</h4>
                      <div class="form-group">
                        <base-input
                          name="stage_two.startDate"
                          v-model="model.stage_two.start_date"
                          v-validate="'required'"
                          placeholder="Start date"
                        >
                          <el-date-picker
                            type="date"
                            v-model="model.stage_two.start_date"
                            :picker-options="startDatePickerOptions"
                            :disabled="!isStageTwoEditable"
                            placeholder="Start date"
                          >
                          </el-date-picker>
                        </base-input>
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.end_date') }}</h4>
                      <div class="form-group">
                        <base-input
                          name="stage_two.endDate"
                          v-model="model.stage_two.end_date"
                          v-validate="'required'"
                          placeholder="End date"
                        >
                          <el-date-picker
                            type="date"
                            v-model="model.stage_two.end_date"
                            :picker-options="endDatePickerOptions"
                            :disabled="!isStageTwoEditable"
                            placeholder="End date"
                          >
                          </el-date-picker>
                        </base-input>
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.main_objective') }}</h4>
                      <div class="form-group">
                        <div class="mt-3">
                          <radio name="stage_two.main_objective"
                             class="form-check-inline"
                             value="1"
                             :disabled="!isStageTwoEditable"
                             v-model="model.stage_two.main_objective"
                          >
                            {{ $t('stage_two.main_objective_a') }}
                          </radio>
                        </div>
                        <div class="mt-3">
                          <radio name="stage_two.main_objective"
                             class="form-check-inline"
                             value="2"
                             :disabled="!isStageTwoEditable"
                             v-model="model.stage_two.main_objective"
                          >
                            {{ $t('stage_two.main_objective_b') }}
                          </radio>
                        </div>
                        <div class="mt-3">
                          <radio name="stage_two.main_objective"
                             class="form-check-inline"
                             value="3"
                             :disabled="!isStageTwoEditable"
                             v-model="model.stage_two.main_objective"
                          >
                            {{ $t('stage_two.main_objective_c') }}
                          </radio>
                        </div>
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.second_objectives') }}</h4>
                      <div class="form-group">
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.stage_two.second_objectives_conservation_of_biodiversity">
                          {{ $t('stage_two.second_objectives_conservation_of_biodiversity') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.stage_two.second_objectives_sustainable_use_of_biodiversity">
                          {{ $t('stage_two.second_objectives_sustainable_use_of_biodiversity') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.stage_two.second_objectives_ecosystem_based_climate">
                          {{ $t('stage_two.second_objectives_ecosystem_based_climate') }}
                        </base-checkbox>
                      </div>


                      <h4 class="card-title">{{ $t('stage_two.grant_amount') }}</h4>
                      <div class="form-group">
                        <currency-input
                          class="form-control"
                          name="stage_two.grant_amount"
                          v-model="model.stage_two.grant_amount"
                          :disabled="!isStageTwoEditable"
                          :value-range='{"min": 0, "max": 50000}'
                          currency="EUR"
                          locale="de"
                          v-validate="'required'"
                          placeholder=""
                        />
                      </div>

                      <h4 class="card-title mb-0">{{ $t('stage_two.short_description') }}</h4>
                      <p>{{ $t('stage_two.short_description_sub') }}</p>
                      <p>{{ $t('stage_two.general_words_remaining', {words: shortDescriptionWordsRemaining}) }}</p>
                      <div class="form-group">
                        <textarea
                          class="form-control"
                          name="stage_two.short_description"
                          v-model="model.stage_two.short_description"
                          @keyup="onShortDescriptionKeyUp"
                          :disabled="!isStageTwoEditable"
                          v-validate="'required'"
                          :placeholder="$t('stage_two.short_description_placeholder')"
                        >
                        </textarea>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <div class="row">
                        <div class="col-lg-6">
                          <h4 class="card-title">{{ $t('stage_two.main_intervention_area') }}</h4>
                          <div class="form-group row mb-4">
                            <div class="col-4">
                              <div class="mt-3" style="height: 40px">
                                <radio name="stage_two.main_intervention_area"
                                   class="form-check-inline"
                                   value="1"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_coastal') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="stage_two.main_intervention_area"
                                   class="form-check-inline"
                                   value="2"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_marine') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="stage_two.main_intervention_area"
                                   class="form-check-inline"
                                   value="3"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_forest') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="stage_two.main_intervention_area"
                                   class="form-check-inline"
                                   value="4"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_terrestrial') }}
                                </radio>
                              </div>
                            </div>
                            <div class="col-8">
                              <div class="mt-3" style="height: 40px">
                                  <radio name="stage_two.main_intervention_area"
                                  class="form-check-inline"
                                  value="5"
                                  :disabled="!isStageTwoEditable"
                                  v-model="model.stage_two.main_intervention_area"
                                  >
                                  {{ $t('stage_two.main_intervention_area_fresh_water') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="stage_two.main_intervention_area"
                                   class="form-check-inline"
                                   value="6"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_ecosystem_services_management') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="stage_two.main_intervention_area"
                                   class="form-check-inline"
                                   value="7"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_species') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="stage_two.main_intervention_area"
                                   class="form-check-inline"
                                   value="8"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_protected_areas') }}
                                </radio>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <h4 class="card-title">{{ $t('stage_two.other_intervention_area') }}</h4>
                          <div class="form-group row">
                            <div class="col-4">
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_intervention_area_costal">
                                {{ $t('stage_two.other_intervention_area_coastal') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_intervention_area_marine">
                                {{ $t('stage_two.other_intervention_area_marine') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_intervention_area_forest">
                                {{ $t('stage_two.other_intervention_area_forest') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_intervention_area_terrestrial">
                                {{ $t('stage_two.other_intervention_area_terrestrial') }}
                              </base-checkbox>
                            </div>
                            <div class="col-8">
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_intervention_area_fresh_water">
                                {{ $t('stage_two.other_intervention_area_fresh_water') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_intervention_area_ecosystem_services_management">
                                {{ $t('stage_two.other_intervention_area_ecosystem_services_management') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_intervention_area_species">
                                {{ $t('stage_two.other_intervention_area_species') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_intervention_area_protected_areas">
                                {{ $t('stage_two.other_intervention_area_protected_areas') }}
                              </base-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <div class="row">
                        <div class="col-lg-6">
                          <h4 class="card-title">{{ $t('stage_two.main_type_of_intervention') }}</h4>
                          <div class="form-group row mb-4">
                            <div class="col-12">
                              <div class="mt-3" style="height: 25px" >
                                <radio name="stage_two.main_type_of_intervention"
                                   class="form-check-inline"
                                   value="1"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_type_of_intervention"
                                >
                                  {{ $t('stage_two.main_type_of_intervention_conservation') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 25px" >
                                <radio name="stage_two.main_type_of_intervention"
                                   class="form-check-inline"
                                   value="2"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_type_of_intervention"
                                >
                                  {{ $t('stage_two.main_type_of_intervention_restoration') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 25px" >
                                <radio name="stage_two.main_type_of_intervention"
                                   class="form-check-inline"
                                   value="3"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_type_of_intervention"
                                >
                                  {{ $t('stage_two.main_type_of_intervention_threat_management') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 25px" >
                                <radio name="stage_two.main_type_of_intervention"
                                   class="form-check-inline"
                                   value="4"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_type_of_intervention"
                                >
                                  {{ $t('stage_two.main_type_of_intervention_awareness') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 25px" >
                                <radio name="stage_two.main_type_of_intervention"
                                   class="form-check-inline"
                                   value="other"
                                   :disabled="!isStageTwoEditable"
                                   v-model="model.stage_two.main_type_of_intervention"
                                >
                                  {{ $t('stage_two.main_type_of_intervention_other') }}
                                </radio>
                              </div>
                            </div>
                            <input
                              type="text"
                              class="form-control mt-2"
                              name="stage_two.main_type_of_intervention_other_specify"
                              v-model="model.stage_two.main_type_of_intervention_other_specify"
                              v-if="model.stage_two.main_type_of_intervention === 'other'"
                              :placeholder="$t('stage_two.main_type_of_intervention_other_placeholder')"
                            />
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <h4 class="card-title">{{ $t('stage_two.other_type_of_intervention') }}</h4>
                          <div class="form-group row">
                            <div class="col-12">
                              <base-checkbox name="checkbox" class="mt-3" style="height: 25px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_type_of_intervention_conservation">
                                {{ $t('stage_two.other_type_of_intervention_conservation') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 25px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_type_of_intervention_restoration">
                                {{ $t('stage_two.other_type_of_intervention_restoration') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 25px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_type_of_intervention_threat_management">
                                {{ $t('stage_two.other_type_of_intervention_threat_management') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 25px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_type_of_intervention_awareness">
                                {{ $t('stage_two.other_type_of_intervention_awareness') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 25px" :disabled="!isStageTwoEditable" v-model="model.stage_two.other_type_of_intervention_other">
                                {{ $t('stage_two.other_type_of_intervention_other') }}
                              </base-checkbox>
                            </div>
                            <input
                              type="text"
                              class="form-control mt-2"
                              name="stage_two.other_type_of_intervention_other_specify"
                              v-model="model.stage_two.other_type_of_intervention_other_specify"
                              v-if="model.stage_two.other_type_of_intervention_other"
                              :placeholder="$t('stage_two.other_type_of_intervention_other_placeholder')"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <div class="file-form-group mb-3">
                        <span class="file-caption">{{ $t('stage_two.project_proposal') }}</span>
                        <upload-file
                          v-model="model.files.stage_two.project_proposal"
                          class="upload-file"
                          :file-data="model.files.stage_two.project_proposal"
                          :is-additional="true"
                          :is-editable="isStageTwoEditable"
                          :allowed-file-type="'pdf'"
                          section="stage_two.project_proposal"
                          >
                        </upload-file>
                      </div>
                      <div class="file-form-group mb-3">
                        <span class="file-caption">{{ $t('stage_two.budget') }}</span>
                        <upload-file
                          v-model="model.files.stage_two.budget"
                          class="upload-file"
                          :file-data="model.files.stage_two.budget"
                          :is-additional="true"
                          :is-editable="isStageTwoEditable"
                          :allowed-file-type="'xls|xlsx'"
                          section="stage_two.budget"
                          >
                        </upload-file>
                      </div>
                      <div class="file-form-group mb-3">
                        <span class="file-caption">{{ $t('stage_two.esms_questionnaire') }}</span>
                        <upload-file
                          v-model="model.files.stage_two.esms_questionnaire"
                          class="upload-file"
                          :file-data="model.files.stage_two.esms_questionnaire"
                          :is-additional="true"
                          :is-editable="isStageTwoEditable"
                          section="stage_two.esms_questionnaire"
                          >
                        </upload-file>
                      </div>
                    </div>

                    <div class="col-lg-12 mb-5">
                      <h4 class="card-title mb-0">{{ $t('stage_two.other_documents') }}</h4>
                      <p>{{ $t('stage_two.other_documents_sub') }}</p>
                      <table class="mt-5 mb-2" width="100%">
                        <thead>
                          <th>{{ $t('stage_two.other_documents_heading_name') }}</th>
                          <th>{{ $t('stage_two.other_documents_heading_upload') }}</th>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in model.stage_two.other_documents" :key="'result_'+index">
                            <td>
                              <textarea
                                class="form-control"
                                :placeholder="$t('stage_two.other_documents_placeholder')"
                                v-model="item.result"
                              >
                              </textarea>
                            </td>
                            <td>
                              <upload-file
                                v-if="initialized"
                                v-model="model.files.stage_two['other_documents' + (index+1)]"
                                class="upload-file"
                                :file-data="model.files.stage_two['other_documents' + (index+1)]"
                                :is-editable="isStageTwoEditable"
                                :section="'stage_two.other_documents' + (index + 1)"
                                >
                              </upload-file>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <base-button
                        type="primary"
                        @click.native="addOtherDocument"
                        v-if="isStageTwoEditable"
                        class="ml-2"
                        >
                        <i class="tim-icons icon-simple-add mr-2"></i> {{ $t('stage_two.general_add_row') }}
                      </base-button>
                      <span class="ml-3" v-if="isStageTwoEditable">{{ $t('stage_two.general_add_row_help') }}</span>
                    </div>

                    <div class="col-12">
                      <h3>{{ $t('stage_two.logical_framework_title') }}</h3>
                      <table class="mb-2 table-bordered logical-framework-table" style="table-layout: fixed" width="100%">
                        <tbody>
                          <tr>
                            <td colspan="2" style="text-align: right">
                              <b>{{ $t('stage_two.logical_framework_general_objective') }}</b><br>
                              {{ $t('stage_two.logical_framework_general_objective_sub') }}
                            </td>
                            <td colspan="3" style="text-align: left">
                              <input
                                type="text"
                                v-model="model.stage_two.general_objective_project"
                                :disabled="!isStageTwoEditable"
                                :placeholder="$t('stage_two.logical_framework_general_objective_placeholder')"
                                style="border: none; width: 100%" />
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2" style="text-align: right">
                              <b>{{ $t('stage_two.project_objective') }}</b><br>
                              {{ $t('stage_two.project_objective_sub') }}
                            </td>
                            <td colspan="3" style="text-align: left">
                              <input type="text" v-model="model.stage_two.project_objective" :disabled="!isStageTwoEditable" :placeholder="$t('stage_two.project_objective_placeholder')" style="border: none; width: 100%" />
                            </td>
                          </tr>
                          <tr>
                            <td width="19%"><b>{{ $t('stage_two.logical_framework_expected_results') }}</b></td>
                            <td width="19%"><b>{{ $t('stage_two.logical_framework_activities') }}</b></td>
                            <td width="24%"><b>{{ $t('stage_two.logical_framework_milestones') }}</b></td>
                            <td width="16%"><b>{{ $t('stage_two.logical_framework_indicators') }}</b></td>
                            <td width="22%"><b>{{ $t('stage_two.logical_framework_verification_means') }}</b></td>
                          </tr>
                          <tr>
                            <td width="19%"><b>{{ $t('stage_two.logical_framework_expected_results_help') }}</b></td>
                            <td width="19%"><b>{{ $t('stage_two.logical_framework_activities_help') }}</b></td>
                            <td width="24%"><b>{{ $t('stage_two.logical_framework_milestones_help') }}</b></td>
                            <td width="16%"><b v-html="$t('stage_two.logical_framework_indicators_help')"></b></td>
                            <td width="22%"><b>{{ $t('stage_two.logical_framework_verification_means_help') }}</b></td>
                          </tr>
                          <tr v-for="(result, index) in model.stage_two.results" :key="'results_' + index">
                            <td v-if="isStageTwoEditable">
                              <textarea :placeholder="$t('stage_two.logical_framework_expected_results_placeholder')" :disabled="!isStageTwoEditable" v-model="result.title" style="border: none; width: 100%"></textarea>
                              <a class="remove-entry-btn" v-if="isStageTwoEditable" @click="removeEntry(model.stage_two.results, index)">X</a>
                            </td>
                            <td v-if="!isStageTwoEditable">{{ result.title }}</td>
                            <td colspan="4" style="text-align: left; padding: 0">
                              <table width="100%">
                                <colgroup>
                                  <col width="25%">
                                  <col width="25%">
                                  <col width="25%">
                                  <col width="25%">
                                </colgroup>
                                <tr v-for="(activity, a_index) in result.activities" :key="'activity_' + index + '_' + a_index">
                                  <td style="border-right: 1px solid #000">
                                    <textarea :placeholder="$t('stage_two.general_insert_placeholder')" :disabled="!isStageTwoEditable" v-model="activity.title" style="border: none"></textarea>
                                    <a class="remove-entry-btn" v-if="isStageTwoEditable" @click="removeEntry(result.activities, a_index)">X</a>
                                  </td>
                                  <td style="text-align: left; padding: 0; border-right: 1px solid #000">
                                    <table width="100%">
                                      <tr v-for="(deliverable, d_index) in activity.deliverables" :key="'deliverable_' + index + '_' + d_index">
                                        <td>
                                          <textarea :placeholder="$t('stage_two.general_insert_placeholder')" :disabled="!isStageTwoEditable" v-model="activity.deliverables[d_index]" style="border: none"></textarea>
                                          <a class="remove-entry-btn" v-if="isStageTwoEditable" @click="removeEntry(activity.deliverables, d_index)">X</a>
                                        </td>
                                      </tr>
                                    </table>
                                    <a class="btn btn-primary m-2" style="color: #fff"  v-if="isStageTwoEditable" v-on:click="addNewDeliverableLine(activity)">{{ $t('stage_two.general_insert_new_line') }}</a>
                                  </td>
                                  <td style="text-align: left; padding: 0; border-right: 1px solid #000">
                                    <table width="100%">
                                      <tr v-for="(indicator, i_index) in activity.indicators" :key="'indicator_' + index + '_' + i_index">
                                        <td>
                                          <textarea :placeholder="$t('stage_two.general_insert_placeholder')" :disabled="!isStageTwoEditable" v-model="indicator.title" style="border: none"></textarea>
                                          <a class="remove-entry-btn" v-if="isStageTwoEditable" @click="removeEntry(activity.indicators, i_index)">X</a>
                                        </td>
                                      </tr>
                                    </table>
                                    <a class="btn btn-primary m-2" style="color: #fff"  v-if="isStageTwoEditable" v-on:click="addNewIndicatorLine(activity)">{{ $t('stage_two.general_insert_new_line') }}</a>
                                  </td>
                                  <td style="text-align: left; padding: 0">
                                    <table width="100%">
                                      <tr v-for="(verification, v_index) in activity.verifications" :key="'verification_' + index + '_' + v_index">
                                        <td>
                                          <textarea :placeholder="$t('stage_two.general_insert_placeholder')" :disabled="!isStageTwoEditable" v-model="activity.verifications[v_index]" style="border: none"></textarea>
                                          <a class="remove-entry-btn" v-if="isStageTwoEditable" @click="removeEntry(activity.verifications, v_index)">X</a>
                                        </td>
                                      </tr>
                                    </table>
                                    <a class="btn btn-primary m-2" style="color: #fff"  v-if="isStageTwoEditable" v-on:click="addNewVerificationLine(activity)">{{ $t('stage_two.general_insert_new_line') }}</a>
                                  </td>
                                </tr>
                              </table>
                              <a class="btn btn-primary m-2" style="color: #fff"  v-if="isStageTwoEditable" v-on:click="addNewActivityLine(result)">{{ $t('stage_two.general_insert_new_line') }}</a>
                            </td>
                          </tr>
                          <tr v-if="isStageTwoEditable">
                            <td colspan="5" style="text-align: left; padding: 10px">
                              <a class="btn btn-primary" style="color: #fff" v-on:click="addNewResultLine()">{{ $t('stage_two.general_insert_new_line') }}</a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-12 mt-5">
                      <h3>{{ $t('stage_two.logical_framework_related_internation_objective_title')}}</h3>
                      <table class="table-rio mb-2 table-bordered" style="table-layout: fixed" width="100%">
                        <colgroup>
                          <col width="20%">
                          <col width="80%">
                        </colgroup>
                        <tbody>
                          <tr v-for="(result, index) in model.stage_two.results" :key="'results_' + index">
                            <td>{{ result.title }}</td>
                            <td style="text-align: left; padding: 0">
                              <table width="100%">
                                <colgroup>
                                  <col width="20%">
                                  <col width="20%">
                                  <col width="60%">
                                </colgroup>
                                <template v-for="(activity, a_index) in result.activities">
                                  <tr v-for="(indicator, i_index) in activity.indicators" :key="'indicator_' + a_index + '_' + i_index">
                                    <td style="border-right: 1px solid #000; text-align: center">
                                      {{ indicator.title }}
                                    </td>
                                    <td style="border-right: 1px solid #000; text-align: center; padding: 0">
                                      <base-button class="m-2" type="primary" v-if="isStageTwoEditable" @click="selectObjectives(indicator)">
                                        {{ $t('stage_two.logical_framework_indicators_objective_button') }}
                                      </base-button>
                                    </td>
                                    <td style="text-align: left; padding: 0">
                                      <table width="100%">
                                        <tr v-if="objective" v-for="(objective, o_index) in indicator.objectives" :key="'indicator_' + index + '_' + o_index">
                                          <td>
                                            {{ $t('stage_two.logical_framework_indicators_objective_' + o_index) }}
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </template>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-12 mt-4" v-if="isStageTwoEditable">
                      <base-button native-type="submit" type="primary" size="lg" class="btn-fill">
                        {{ $t('stage_two.save_button') }}
                      </base-button>
                      <base-button v-on:click="submitStageTwo" native-type="submit" type="secondary" size="lg ml-3" class="btn-fill float-right">
                        {{ $t('stage_two.submit_button') }}
                      </base-button>
                    </div>
                  </tab-pane>
                  <tab-pane id="revised" :label="$t('full_proposal.revision_tab__revised_version')" v-if="model.revision && model.revision.revision_id">
                    <div class="col-lg-6 mb-4">
                      <h4 class="card-title">{{ $t('stage_two.title') }}</h4>
                      <div class="form-group">
                        <textarea
                          class="form-control"
                          name="evaluation_data.title"
                          v-model="model.evaluation_data.title"
                          disabled="disabled"
                          v-validate="'required'"
                          :placeholder="$t('stage_two.title_placeholder')"
                        >
                        </textarea>
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.lead_applicant') }}</h4>
                      <div class="form-group">
                        <textarea
                          class="form-control"
                          name="evaluation_data.lead_applicant_name"
                          v-model="organization"
                          disabled="disbaled"
                          v-validate="'required'"
                          :placeholder="$t('stage_two.lead_applicant_placeholder')"
                        >
                        </textarea>
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.lead_applicant_type') }}</h4>
                      <div class="form-group">
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.evaluation_data.organization_type.non_governmental_organisation">
                          {{ $t('stage_two.non_governmental_organisation') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.evaluation_data.organization_type.small_socio_professional_organisation">
                          {{ $t('stage_two.small_socio_professional_organisation') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.evaluation_data.organization_type.sub_national_local_authorities_of_ors">
                          {{ $t('stage_two.sub_national_local_authorities_of_ors') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.evaluation_data.organization_type.local_government_departments">
                          {{ $t('stage_two.local_government_departments') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isStageTwoEditable" v-model="model.evaluation_data.organization_type.national_or_local_research_organisation">
                          {{ $t('stage_two.national_or_local_research_organisation') }}
                        </base-checkbox>
                      </div>

                      <div class="mt-3">
                        <h4 class="card-title d-inline-block mr-3">{{ $t('stage_two.co_applicant') }}</h4>
                        <radio name="model.revision.data.has_co_applicant"
                               class="form-check-inline"
                               value="YES"
                               :disabled="!isRevisionEditable"
                               v-model="model.revision.data.has_co_applicant"
                        >
                          <label>{{ $t('stage_two.general_yes') }}</label>
                        </radio>
                        <radio name="model.revision.data.has_co_applicant"
                               class="form-check-inline"
                               value="NO"
                               :disabled="!isRevisionEditable"
                               v-model="model.revision.data.has_co_applicant"
                        >
                          <label>{{ $t('stage_two.general_no') }}</label>
                        </radio>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          name="revision.data.name_of_co_applicants"
                          v-model="model.revision.data.name_of_co_applicants"
                          :disabled="model.revision.data.has_co_applicant === 'NO' || !isRevisionEditable"
                          v-validate="'required'"
                          :placeholder="$t('stage_two.co_applicant_placeholder')"
                        />
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.start_date') }}</h4>
                      <div class="form-group">
                        <base-input
                          name="revision.data.startDate"
                          v-model="model.revision.data.start_date"
                          v-validate="'required'"
                          placeholder="Start date"
                        >
                          <el-date-picker
                            type="date"
                            v-model="model.revision.data.start_date"
                            :picker-options="revisionStartDatePickerOptions"
                            :disabled="!isRevisionEditable"
                            placeholder="Start date"
                          >
                          </el-date-picker>
                        </base-input>
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.end_date') }}</h4>
                      <div class="form-group">
                        <base-input
                          name="revision.data.endDate"
                          v-model="model.revision.data.end_date"
                          v-validate="'required'"
                          placeholder="End date"
                        >
                          <el-date-picker
                            type="date"
                            v-model="model.revision.data.end_date"
                            :picker-options="revisionEndDatePickerOptions"
                            :disabled="!isRevisionEditable"
                            placeholder="End date"
                          >
                          </el-date-picker>
                        </base-input>
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.main_objective') }}</h4>
                      <div class="form-group">
                        <div class="mt-3">
                          <radio name="revision.data.main_objective"
                             class="form-check-inline"
                             value="1"
                             :disabled="!isRevisionEditable"
                             v-model="model.revision.data.main_objective"
                          >
                            {{ $t('stage_two.main_objective_a') }}
                          </radio>
                        </div>
                        <div class="mt-3">
                          <radio name="revision.data.main_objective"
                             class="form-check-inline"
                             value="2"
                             :disabled="!isRevisionEditable"
                             v-model="model.revision.data.main_objective"
                          >
                            {{ $t('stage_two.main_objective_b') }}
                          </radio>
                        </div>
                        <div class="mt-3">
                          <radio name="revision.data.main_objective"
                             class="form-check-inline"
                             value="3"
                             :disabled="!isRevisionEditable"
                             v-model="model.revision.data.main_objective"
                          >
                            {{ $t('stage_two.main_objective_c') }}
                          </radio>
                        </div>
                      </div>

                      <h4 class="card-title">{{ $t('stage_two.second_objectives') }}</h4>
                      <div class="form-group">
                        <base-checkbox name="checkbox" :disabled="!isRevisionEditable" v-model="model.revision.data.second_objectives_conservation_of_biodiversity">
                          {{ $t('stage_two.second_objectives_conservation_of_biodiversity') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isRevisionEditable" v-model="model.revision.data.second_objectives_sustainable_use_of_biodiversity">
                          {{ $t('stage_two.second_objectives_sustainable_use_of_biodiversity') }}
                        </base-checkbox>
                        <base-checkbox name="checkbox" :disabled="!isRevisionEditable" v-model="model.revision.data.second_objectives_ecosystem_based_climate">
                          {{ $t('stage_two.second_objectives_ecosystem_based_climate') }}
                        </base-checkbox>
                      </div>


                      <h4 class="card-title">{{ $t('stage_two.grant_amount') }}</h4>
                      <div class="form-group">
                        <currency-input
                          class="form-control"
                          name="revision.data.grant_amount"
                          v-model="model.revision.data.grant_amount"
                          :disabled="!isRevisionEditable"
                          :value-range='{"min": 0, "max": 50000}'
                          currency="EUR"
                          locale="de"
                          v-validate="'required'"
                          placeholder=""
                        />
                      </div>

                      <h4 class="card-title mb-0">{{ $t('stage_two.short_description') }}</h4>
                      <p>{{ $t('stage_two.short_description_sub') }}</p>
                      <p>{{ $t('stage_two.general_words_remaining', {words: shortDescriptionWordsRemaining}) }}</p>
                      <div class="form-group">
                        <textarea
                          class="form-control"
                          name="revision.data.short_description"
                          v-model="model.revision.data.short_description"
                          @keyup="onShortDescriptionKeyUp"
                          :disabled="!isRevisionEditable"
                          v-validate="'required'"
                          :placeholder="$t('stage_two.short_description_placeholder')"
                        >
                        </textarea>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <div class="row">
                        <div class="col-lg-6">
                          <h4 class="card-title">{{ $t('stage_two.main_intervention_area') }}</h4>
                          <div class="form-group row mb-4">
                            <div class="col-4">
                              <div class="mt-3" style="height: 40px">
                                <radio name="revision.data.main_intervention_area"
                                   class="form-check-inline"
                                   value="1"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_coastal') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="revision.data.main_intervention_area"
                                   class="form-check-inline"
                                   value="2"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_marine') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="revision.data.main_intervention_area"
                                   class="form-check-inline"
                                   value="3"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_forest') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="revision.data.main_intervention_area"
                                   class="form-check-inline"
                                   value="4"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_terrestrial') }}
                                </radio>
                              </div>
                            </div>
                            <div class="col-8">
                              <div class="mt-3" style="height: 40px">
                                  <radio name="revision.data.main_intervention_area"
                                  class="form-check-inline"
                                  value="5"
                                  :disabled="!isRevisionEditable"
                                  v-model="model.revision.data.main_intervention_area"
                                  >
                                  {{ $t('stage_two.main_intervention_area_fresh_water') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="revision.data.main_intervention_area"
                                   class="form-check-inline"
                                   value="6"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_ecosystem_services_management') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="revision.data.main_intervention_area"
                                   class="form-check-inline"
                                   value="7"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_species') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 40px">
                                <radio name="revision.data.main_intervention_area"
                                   class="form-check-inline"
                                   value="8"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_intervention_area"
                                >
                                  {{ $t('stage_two.main_intervention_area_protected_areas') }}
                                </radio>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <h4 class="card-title">{{ $t('stage_two.other_intervention_area') }}</h4>
                          <div class="form-group row">
                            <div class="col-4">
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_intervention_area_costal">
                                {{ $t('stage_two.other_intervention_area_coastal') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_intervention_area_marine">
                                {{ $t('stage_two.other_intervention_area_marine') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_intervention_area_forest">
                                {{ $t('stage_two.other_intervention_area_forest') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_intervention_area_terrestrial">
                                {{ $t('stage_two.other_intervention_area_terrestrial') }}
                              </base-checkbox>
                            </div>
                            <div class="col-8">
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_intervention_area_fresh_water">
                                {{ $t('stage_two.other_intervention_area_fresh_water') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_intervention_area_ecosystem_services_management">
                                {{ $t('stage_two.other_intervention_area_ecosystem_services_management') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_intervention_area_species">
                                {{ $t('stage_two.other_intervention_area_species') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 40px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_intervention_area_protected_areas">
                                {{ $t('stage_two.other_intervention_area_protected_areas') }}
                              </base-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <div class="row">
                        <div class="col-lg-6">
                          <h4 class="card-title">{{ $t('stage_two.main_type_of_intervention') }}</h4>
                          <div class="form-group row mb-4">
                            <div class="col-12">
                              <div class="mt-3" style="height: 25px" >
                                <radio name="revision.data.main_type_of_intervention"
                                   class="form-check-inline"
                                   value="1"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_type_of_intervention"
                                >
                                  {{ $t('stage_two.main_type_of_intervention_conservation') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 25px" >
                                <radio name="revision.data.main_type_of_intervention"
                                   class="form-check-inline"
                                   value="2"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_type_of_intervention"
                                >
                                  {{ $t('stage_two.main_type_of_intervention_restoration') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 25px" >
                                <radio name="revision.data.main_type_of_intervention"
                                   class="form-check-inline"
                                   value="3"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_type_of_intervention"
                                >
                                  {{ $t('stage_two.main_type_of_intervention_threat_management') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 25px" >
                                <radio name="revision.data.main_type_of_intervention"
                                   class="form-check-inline"
                                   value="4"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_type_of_intervention"
                                >
                                  {{ $t('stage_two.main_type_of_intervention_awareness') }}
                                </radio>
                              </div>
                              <div class="mt-3" style="height: 25px" >
                                <radio name="revision.data.main_type_of_intervention"
                                   class="form-check-inline"
                                   value="other"
                                   :disabled="!isRevisionEditable"
                                   v-model="model.revision.data.main_type_of_intervention"
                                >
                                  {{ $t('stage_two.main_type_of_intervention_other') }}
                                </radio>
                              </div>
                            </div>
                            <input
                              type="text"
                              class="form-control mt-2"
                              name="stage_two.main_type_of_intervention_other_specify"
                              v-model="model.revision.data.main_type_of_intervention_other_specify"
                              v-if="model.revision.data.main_type_of_intervention === 'other'"
                              :placeholder="$t('stage_two.main_type_of_intervention_other_placeholder')"
                            />
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <h4 class="card-title">{{ $t('stage_two.other_type_of_intervention') }}</h4>
                          <div class="form-group row">
                            <div class="col-12">
                              <base-checkbox name="checkbox" class="mt-3" style="height: 25px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_type_of_intervention_conservation">
                                {{ $t('stage_two.other_type_of_intervention_conservation') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 25px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_type_of_intervention_restoration">
                                {{ $t('stage_two.other_type_of_intervention_restoration') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 25px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_type_of_intervention_threat_management">
                                {{ $t('stage_two.other_type_of_intervention_threat_management') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 25px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_type_of_intervention_awareness">
                                {{ $t('stage_two.other_type_of_intervention_awareness') }}
                              </base-checkbox>
                              <base-checkbox name="checkbox" class="mt-3" style="height: 25px" :disabled="!isRevisionEditable" v-model="model.revision.data.other_type_of_intervention_other">
                                {{ $t('stage_two.other_type_of_intervention_other') }}
                              </base-checkbox>
                            </div>
                            <input
                              type="text"
                              class="form-control mt-2"
                              name="revision.data.other_type_of_intervention_other_specify"
                              v-model="model.revision.data.other_type_of_intervention_other_specify"
                              v-if="model.revision.data.other_type_of_intervention_other"
                              :placeholder="$t('stage_two.other_type_of_intervention_other_placeholder')"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <div class="file-form-group mb-3">
                        <span class="file-caption">{{ $t('stage_two.project_proposal') }}</span>
                        <upload-file
                          v-model="model.files.revision.project_proposal"
                          class="upload-file"
                          :file-data="model.files.revision.project_proposal"
                          :is-additional="true"
                          :is-editable="isRevisionEditable"
                          :allowed-file-type="'pdf'"
                          section="revision.project_proposal"
                          >
                        </upload-file>
                      </div>
                      <div class="file-form-group mb-3">
                        <span class="file-caption">{{ $t('stage_two.budget') }}</span>
                        <upload-file
                          v-model="model.files.revision.budget"
                          class="upload-file"
                          :file-data="model.files.revision.budget"
                          :is-additional="true"
                          :is-editable="isRevisionEditable"
                          :allowed-file-type="'xls|xlsx'"
                          section="revision.budget"
                          >
                        </upload-file>
                      </div>
                      <div class="file-form-group mb-3">
                        <span class="file-caption">{{ $t('stage_two.esms_questionnaire') }}</span>
                        <upload-file
                          v-model="model.files.revision.esms_questionnaire"
                          class="upload-file"
                          :file-data="model.files.revision.esms_questionnaire"
                          :is-additional="true"
                          :is-editable="isRevisionEditable"
                          section="revision.esms_questionnaire"
                          >
                        </upload-file>
                      </div>
                      <h4 class="card-title">{{$t('revised_stage_two.financial_identification_card_title')}}</h4>
                      <a :href="downloadTemplates[0][$i18n.locale]" target="_blank" class="ml-2 btn btn-simple btn-primary">
                        {{$t('revised_stage_two.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                      </a>
                      <div class="file-form-group file-highlighted mb-3">
                        <span class="file-caption">{{ $t('revised_stage_two.financial_identification_title') }}</span>
                        <upload-file
                          v-model="model.files.revision.financial_identification"
                          class="upload-file"
                          :file-data="model.files.revision.financial_identification"
                          :is-additional="true"
                          :is-editable="isRevisionEditable"
                          section="revision.financial_identification"
                          >
                        </upload-file>
                      </div>
                    </div>

                    <div class="col-lg-12 mb-5">
                      <h4 class="card-title mb-0">{{ $t('stage_two.other_documents') }}</h4>
                      <p>{{ $t('stage_two.other_documents_sub') }}</p>
                      <table class="mt-5 mb-2" width="100%">
                        <thead>
                          <th>{{ $t('stage_two.other_documents_heading_name') }}</th>
                          <th>{{ $t('stage_two.other_documents_heading_upload') }}</th>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in model.revision.data.other_documents" :key="'result_'+index">
                            <td>
                              <textarea
                                class="form-control"
                                :placeholder="$t('stage_two.other_documents_placeholder')"
                                v-model="item.result"
                              >
                              </textarea>
                            </td>
                            <td>
                              <upload-file
                                v-if="initialized"
                                v-model="model.files.revision['other_documents' + (index+1)]"
                                class="upload-file"
                                :file-data="model.files.revision['other_documents' + (index+1)]"
                                :is-additional="true"
                                :is-editable="isRevisionEditable"
                                :section="'revision.other_documents' + (index + 1)"
                                >
                              </upload-file>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <base-button
                        type="primary"
                        @click.native="addOtherDocument(model.revision.data)"
                        v-if="isRevisionEditable"
                        class="ml-2"
                        >
                        <i class="tim-icons icon-simple-add mr-2"></i> {{ $t('stage_two.general_add_row') }}
                      </base-button>
                      <span class="ml-3" v-if="isRevisionEditable">{{ $t('stage_two.general_add_row_help') }}</span>
                    </div>

                    <div class="col-12">
                      <h3>{{ $t('stage_two.logical_framework_title') }}</h3>
                      <table class="mb-2 table-bordered logical-framework-table" style="table-layout: fixed" width="100%">
                        <tbody>
                          <tr>
                            <td colspan="2" style="text-align: right">
                              <b>{{ $t('stage_two.logical_framework_general_objective') }}</b><br>
                              {{ $t('stage_two.logical_framework_general_objective_sub') }}
                            </td>
                            <td colspan="3" style="text-align: left">
                              <input
                                type="text"
                                v-model="model.revision.data.general_objective_project"
                                :placeholder="$t('stage_two.logical_framework_general_objective_placeholder')"
                                style="border: none; width: 100%" />
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2" style="text-align: right">
                              <b>{{ $t('stage_two.project_objective') }}</b><br>
                              {{ $t('stage_two.project_objective_sub') }}
                            </td>
                            <td colspan="3" style="text-align: left">
                              <input type="text" v-model="model.revision.data.project_objective" :placeholder="$t('stage_two.project_objective_placeholder')" style="border: none; width: 100%" />
                            </td>
                          </tr>
                          <tr>
                            <td width="19%"><b>{{ $t('stage_two.logical_framework_expected_results') }}</b></td>
                            <td width="19%"><b>{{ $t('stage_two.logical_framework_activities') }}</b></td>
                            <td width="24%"><b>{{ $t('stage_two.logical_framework_milestones') }}</b></td>
                            <td width="16%"><b>{{ $t('stage_two.logical_framework_indicators') }}</b></td>
                            <td width="22%"><b>{{ $t('stage_two.logical_framework_verification_means') }}</b></td>
                          </tr>
                          <tr>
                            <td width="19%"><b>{{ $t('stage_two.logical_framework_expected_results_help') }}</b></td>
                            <td width="19%"><b>{{ $t('stage_two.logical_framework_activities_help') }}</b></td>
                            <td width="24%"><b>{{ $t('stage_two.logical_framework_milestones_help') }}</b></td>
                            <td width="16%"><b v-html="$t('stage_two.logical_framework_indicators_help')"></b></td>
                            <td width="22%"><b>{{ $t('stage_two.logical_framework_verification_means_help') }}</b></td>
                          </tr>
                          <tr v-for="(result, index) in model.revision.data.results" :key="'results_' + index">
                            <td v-if="isRevisionEditable">
                              <textarea :placeholder="$t('stage_two.logical_framework_expected_results_placeholder')" v-model="result.title" style="border: none; width: 100%"></textarea>
                              <a class="remove-entry-btn" @click="removeEntry(model.revision.data.results, index)">X</a>
                            </td>
                            <td v-if="!isRevisionEditable">{{ result.title }}</td>
                            <td colspan="4" style="text-align: left; padding: 0">
                              <table width="100%">
                                <colgroup>
                                  <col width="25%">
                                  <col width="25%">
                                  <col width="25%">
                                  <col width="25%">
                                </colgroup>
                                <tr v-for="(activity, a_index) in result.activities" :key="'activity_' + index + '_' + a_index">
                                  <td style="border-right: 1px solid #000">
                                    <textarea :placeholder="$t('stage_two.general_insert_placeholder')" v-model="activity.title" style="border: none"></textarea>
                                    <a class="remove-entry-btn" @click="removeEntry(result.activities, a_index)">X</a>
                                  </td>
                                  <td style="text-align: left; padding: 0; border-right: 1px solid #000">
                                    <table width="100%">
                                      <tr v-for="(deliverable, d_index) in activity.deliverables" :key="'deliverable_' + index + '_' + d_index">
                                        <td>
                                          <textarea :placeholder="$t('stage_two.general_insert_placeholder')" v-model="activity.deliverables[d_index]" style="border: none"></textarea>
                                          <a class="remove-entry-btn" @click="removeEntry(activity.deliverables, d_index)">X</a>
                                        </td>
                                      </tr>
                                    </table>
                                    <a class="btn btn-primary m-2" style="color: #fff"  v-if="isRevisionEditable" v-on:click="addNewDeliverableLine(activity)">{{ $t('stage_two.general_insert_new_line') }}</a>
                                  </td>
                                  <td style="text-align: left; padding: 0; border-right: 1px solid #000">
                                    <table width="100%">
                                      <tr v-for="(indicator, i_index) in activity.indicators" :key="'indicator_' + index + '_' + i_index">
                                        <td>
                                          <textarea :placeholder="$t('stage_two.general_insert_placeholder')" v-model="indicator.title" style="border: none"></textarea>
                                          <a class="remove-entry-btn" @click="removeEntry(activity.indicators, i_index)">X</a>
                                        </td>
                                      </tr>
                                    </table>
                                    <a class="btn btn-primary m-2" style="color: #fff"  v-if="isRevisionEditable" v-on:click="addNewIndicatorLine(activity)">{{ $t('stage_two.general_insert_new_line') }}</a>
                                  </td>
                                  <td style="text-align: left; padding: 0">
                                    <table width="100%">
                                      <tr v-for="(verification, v_index) in activity.verifications" :key="'verification_' + index + '_' + v_index">
                                        <td>
                                          <textarea :placeholder="$t('stage_two.general_insert_placeholder')" v-model="activity.verifications[v_index]" style="border: none"></textarea>
                                          <a class="remove-entry-btn" @click="removeEntry(activity.verifications, v_index)">X</a>
                                        </td>
                                      </tr>
                                    </table>
                                    <a class="btn btn-primary m-2" style="color: #fff"  v-if="isRevisionEditable" v-on:click="addNewVerificationLine(activity)">{{ $t('stage_two.general_insert_new_line') }}</a>
                                  </td>
                                </tr>
                              </table>
                              <a class="btn btn-primary m-2" style="color: #fff"  v-if="isRevisionEditable" v-on:click="addNewActivityLine(result)">{{ $t('stage_two.general_insert_new_line') }}</a>
                            </td>
                          </tr>
                          <tr v-if="isStageTwoEditable">
                            <td colspan="5" style="text-align: left; padding: 10px">
                              <a class="btn btn-primary" style="color: #fff" v-on:click="addNewResultLine(model.revision.data)">{{ $t('stage_two.general_insert_new_line') }}</a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-12 mt-5">
                      <h3>{{ $t('stage_two.logical_framework_related_internation_objective_title')}}</h3>
                      <table class="table-rio mb-2 table-bordered" style="table-layout: fixed" width="100%">
                        <colgroup>
                          <col width="20%">
                          <col width="80%">
                        </colgroup>
                        <tbody>
                          <tr v-for="(result, index) in model.revision.data.results" :key="'results_' + index">
                            <td>{{ result.title }}</td>
                            <td style="text-align: left; padding: 0">
                              <table width="100%">
                                <colgroup>
                                  <col width="20%">
                                  <col width="20%">
                                  <col width="60%">
                                </colgroup>
                                <template v-for="(activity, a_index) in result.activities">
                                  <tr v-for="(indicator, i_index) in activity.indicators" :key="'indicator_' + a_index + '_' + i_index">
                                    <td style="border-right: 1px solid #000; text-align: center">
                                      {{ indicator.title }}
                                    </td>
                                    <td style="border-right: 1px solid #000; text-align: center; padding: 0">
                                      <base-button class="m-2" type="primary" @click="selectObjectives(indicator)">
                                        {{ $t('stage_two.logical_framework_indicators_objective_button') }}
                                      </base-button>
                                    </td>
                                    <td style="text-align: left; padding: 0">
                                      <table width="100%">
                                        <tr v-if="objective" v-for="(objective, o_index) in indicator.objectives" :key="'indicator_' + index + '_' + o_index">
                                          <td>
                                            {{ $t('stage_two.logical_framework_indicators_objective_' + o_index) }}
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </template>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-12 mt-4" v-if="isRevisionEditable">
                      <base-button native-type="submit" type="primary" size="lg" class="btn-fill">
                        {{ $t('stage_two.save_button') }}
                      </base-button>
                      <base-button v-on:click="submitRevision" native-type="submit" type="secondary" size="lg ml-3" class="btn-fill float-right">
                        {{ $t('stage_two.submit_button') }}
                      </base-button>
                    </div>
                  </tab-pane>
                </tabs>
              </tab-pane>
            </tabs>

            <modal :show.sync="modalObjectives.visibility" headerClasses="justify-content-center">
              <h4 slot="header" class="title">{{ $t('stage_two.logical_framework_indicators_objective_title') }}</h4>

              <div class="row" style="width: 700px">
                <div class="col-6">
                  <h4 style="height: 48px">{{ $t('stage_two.logical_framework_indicators_objective_sdg_title') }}</h4>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_01">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_01') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_02">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_02') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_03">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_03') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_04">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_04') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_05">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_05') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_06">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_06') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_07">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_07') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_08">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_08') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_09">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_09') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_10">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_10') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_11">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_11') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_12">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_12') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_13">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_13') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_14">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_14') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_15">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_15') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_16">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_16') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.sdg_17">
                    {{ $t('stage_two.logical_framework_indicators_objective_sdg_17') }}
                  </base-checkbox>
                </div>
                <div class="col-6">
                  <h4 style="height: 48px">{{ $t('stage_two.logical_framework_indicators_objective_targets_title') }}</h4>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_01">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_01') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_02">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_02') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_03">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_03') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_04">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_04') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_05">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_05') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_06">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_06') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_07">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_07') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_08">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_08') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_09">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_09') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_10">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_10') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_11">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_11') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_12">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_12') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_13">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_13') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_14">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_14') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_15">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_15') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_16">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_16') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_17">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_17') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_18">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_18') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_19">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_19') }}
                  </base-checkbox>
                  <base-checkbox name="checkbox" class="mb-3" v-model="modalObjectives.indicator.objectives.targets_20">
                    {{ $t('stage_two.logical_framework_indicators_objective_targets_20') }}
                  </base-checkbox>
                </div>
              </div>

              <div class="row">
                <div class="col-6 mt-2">
                  <!-- <base-button type="primary" size="lg" class="btn-fill" @click="saveIndicatorsObjectives()">
                    {{ $t('stage_two.save_button') }}
                  </base-button> -->
                </div>
                <div class="col-6 mt-2 text-right">
                  <base-button type="danger" size="lg" class="btn-fill" @click.native="modalObjectives.visibility = false">
                    Close
                  </base-button>
                </div>
              </div>
            </modal>

          </card>
          <card v-if="initialized && active_tab_id === 'stage-1'">
            <h3 class="card-title" v-if="isEditable">Please choose one or more of the LIFE4BEST-ORs objectives relevant to your application</h3>
            <ul class="best-objectives-list" v-bind:class="{'is-editable': isEditable}">
  						<li v-if="isEditable || model.objectives.conservation_of_biodiversity">
                <label v-if="isEditable" for="first-objective" class="best-checkbox">
                  <input
                    type="checkbox"
                    name="objectives"
                    id="first-objective"
                    v-model="model.objectives.conservation_of_biodiversity"
                    />
                  <span class="best-thumb"></span>
                </label>
                {{$t('documents.objective_1')}}
              </li>
  						<li v-if="isEditable || model.objectives.sustainable_use_of_biodiversity">
                <label v-if="isEditable" for="second-objective" class="best-checkbox">
                  <input
                    type="checkbox"
                    name="objectives"
                    id="second-objective"
                    v-model="model.objectives.sustainable_use_of_biodiversity"
                    />
                  <span class="best-thumb"></span>
                </label>
                {{$t('documents.objective_2')}}
              </li>
  						<li v-if="isEditable || model.objectives.ecosystem_based_climate">
                <label v-if="isEditable" for="third-objective" class="best-checkbox">
                  <input
                    type="checkbox"
                    name="objectives"
                    id="third-objective"
                    v-model="model.objectives.ecosystem_based_climate"
                    />
                  <span class="best-thumb"></span>
                </label>
                {{$t('documents.objective_3')}}
              </li>
  					</ul>
          </card>
          <card v-if="initialized && active_tab_id === 'stage-1'">
            <h3 class="card-title">{{ $t('documents.organization_type') }}</h3>
            <ul class="best-objectives-list" v-bind:class="{'is-editable': isEditable}">
  						<li v-if="isEditable || model.organization_type.non_governmental_organisation">
                <label v-if="isEditable" for="first-organization-type" class="best-checkbox">
                  <input
                    type="checkbox"
                    name="organization_type"
                    id="first-organization-type"
                    v-model="model.organization_type.non_governmental_organisation"
                    />
                  <span class="best-thumb"></span>
                </label>
                {{$t('documents.og_type_non_governmental_organisation')}}
              </li>
  						<li v-if="isEditable || model.organization_type.small_socio_professional_organisation">
                <label v-if="isEditable" for="second-organization-type" class="best-checkbox">
                  <input
                    type="checkbox"
                    name="organization_type"
                    id="second-organization-type"
                    v-model="model.organization_type.small_socio_professional_organisation"
                    />
                  <span class="best-thumb"></span>
                </label>
                {{$t('documents.og_type_small_socio_professional_organisation')}}
              </li>
  						<li v-if="isEditable || model.organization_type.sub_national_local_authorities_of_ors">
                <label v-if="isEditable" for="third-organization-type" class="best-checkbox">
                  <input
                    type="checkbox"
                    name="organization_type"
                    id="third-organization-type"
                    v-model="model.organization_type.sub_national_local_authorities_of_ors"
                    />
                  <span class="best-thumb"></span>
                </label>
                {{$t('documents.og_type_sub_national_local_authorities_of_ors')}}
              </li>
  						<li v-if="isEditable || model.organization_type.local_government_departments">
                <label v-if="isEditable" for="fourth-organization-type" class="best-checkbox">
                  <input
                    type="checkbox"
                    name="organization_type"
                    id="fourth-organization-type"
                    v-model="model.organization_type.local_government_departments"
                    />
                  <span class="best-thumb"></span>
                </label>
                {{$t('documents.og_type_local_government_departments')}}
              </li>
  						<li v-if="isEditable || model.organization_type.national_or_local_research_organisation">
                <label v-if="isEditable" for="fifth-organization-type" class="best-checkbox">
                  <input
                    type="checkbox"
                    name="organization_type"
                    id="fifth-organization-type"
                    v-model="model.organization_type.national_or_local_research_organisation"
                    />
                  <span class="best-thumb"></span>
                </label>
                {{$t('documents.og_type_national_or_local_research_organisation')}}
              </li>
  					</ul>
          </card>
          <div v-if="initialized && isEditable">
            <base-button native-type="submit" type="primary" size="lg" class="btn-fill">
              Save
            </base-button>
            <base-button v-on:click="submitApplication" native-type="submit" type="secondary" size="lg ml-3" class="btn-fill">
              Submit
            </base-button>
            <p v-if="loggedUser.role === UserRoles.APPLICANT" class="mt-5">{{ $t('documents.info_account_deletion') }}</p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import {DocumentService, UserRoles, UserService, FileUploadService} from '@/services';
  import {UploadDocumentsFile, Tabs, TabPane} from '@/components';
  import {Modal} from 'src/components';
  import {Table, TableColumn, DatePicker, Select, Option} from 'element-ui';
  import swal from 'sweetalert2';

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [DatePicker.name]: DatePicker,
      TabPane,
      Tabs,
      Modal,
      UploadDocumentsFile
    },
    data() {
      return {
        UserRoles,
        documents: [],
        loggedUser: {},
        downloadTemplates: [
          {
            en: '/files/en/LIFE4BEST_Financial-Identification.pdf',
            fr: '/files/fr/LIFE4BEST_Coordonnées-bancaires.pdf'
          }
        ],
        startDatePickerOptions: {
          disabledDate (date)
          {
            return date < new Date(2020, 5, 1) || date > new Date(2021, 7, 31);
          }
        },
        endDatePickerOptions: {
          disabledDate (date)
          {
            return date < new Date(2020, 5, 1) || date > new Date(2021, 7, 31);
          }
        },
        revisionStartDatePickerOptions: {
          disabledDate (date)
          {
            return date < new Date(2020, 5, 1) || date > new Date(2021, 9, 31);
          }
        },
        revisionEndDatePickerOptions: {
          disabledDate (date)
          {
            return date < new Date(2020, 5, 1) || date > new Date(2021, 9, 31);
          }
        },
        modalObjectives: {
          visibility: false,
          objectives: {},
          indicator: {
            objectives: {}
          }
        },
        initialized: false,
        organization: '',
        active_tab_id: 'stage-1',
        userId: parseInt(this.$route.params.userId) || null,
        applicationStatuses: [
          'DRAFT',
          'SUBMITTED'
        ],
        isEditable: true,
        isStageTwoEditable: true,
        isRevisionEditable: true,
        referenceNr: '',
        userDetails: {},
        maxWords: 500,
        shortDescriptionWordsRemaining: 500,
        model: {
          objectives: {},
          organization_type: {},
          application_status: '',
          stage_two_status: '',
          stage_two:
          {
            general_objective_project: '',
            project_objective: '',
            results: [
              {
                activities: [
                  'Activity 1.1:',
                  'Activity 1.2:',
                  'Activity 1.3:',
                ],
                deliverables: [
                  'Deliverable/Milestone 1.1:',
                  'Deliverable/Milestone 1.2:',
                  'Deliverable/Milestone 1.3:',
                ]
              }
            ],
          },
          revision: {

          },
          files: {
            stage_two: {},
            revision: {}
          },
        }
      }
    },
    methods: {
      async getUserDetails(userId) {
        let vm = this;
        await UserService.getUserDetails(userId).then(function (response) {
          vm.userDetails = response.data;
        })
      },
      async getApplicantData(userId) {
        let vm = this;

        await UserService.getApplicantData(userId).then(function (response) {
          vm.model = {...vm.model, ...response.data};
        });
      },
      async getMyApplicantData() {
        let vm = this;

        await UserService.getMyApplicantData().then(function (response) {
          vm.model = {...vm.model, ...response.data};
        });
      },
      async getItems() {
        let vm = this;
        let loader = vm.$loading.show();

        if (vm.loggedUser.role !== UserRoles.APPLICANT && vm.userId) {
          if (vm.userId !== vm.loggedUser.id) {
            vm.isEditable = false;
          }

          vm.isStageTwoEditable = false;
          vm.isRevisionEditable = false;

          await vm.getUserDetails(vm.userId);
          await vm.getUserDocuments(vm.userId);
          await vm.getApplicantData(vm.userId);
        } else {
          await vm.getMyDocuments();
          await vm.getMyApplicantData();
        }

        vm.organization = vm.userDetails.organization || vm.loggedUser.organization;

        let value = vm.model.stage_two.short_description || '';
        let words = value.split(/\s/);

        vm.shortDescriptionWordsRemaining = Math.max(0, vm.maxWords - words.length);

        if (vm.model.application_status === 'SUBMITTED' || vm.loggedUser.locked) {
          vm.isEditable = false;
        }

        if (vm.model.stage_two_status === 'SUBMITTED' || vm.loggedUser.locked) {
          vm.isStageTwoEditable = false;
        }

        if (vm.model.revision && (vm.model.revision.status === 'SUBMITTED' || vm.model.revision.locked)) {
          vm.isRevisionEditable = false;
        }

        loader.hide();
      },
      async getMyDocuments() {
        let vm = this;
        await DocumentService.getMyDocuments().then(function (response) {
          vm.documents = response.data;
        })
      },
      async getUserDocuments(userId) {
        let vm = this;
        await DocumentService.getUserDocuments(userId).then(function (response) {
          vm.documents = response.data;
        })
      },
      async updateProfile() {
        let vm = this;
        let isValidForm = true;

        if (isValidForm) {

          vm.model.organization = vm.organization;

          let loader = this.$loading.show();
          let updateRequest = UserService.updateApplicantData(this.model);

          await updateRequest.then(() => {
            this.$store.dispatch('Auth/init');
            LocalizationService.init();

          }).catch(() => {

          });

          if (vm.model.application_status === 'SUBMITTED') {
            vm.isEditable = false;
          }

          if (vm.model.stage_two_status === 'SUBMITTED') {
            vm.isStageTwoEditable = false;
          }

          if (vm.model.revision &&  vm.model.revision.data === 'SUBMITTED') {
            vm.isRevisionEditable = false;
          }

          await vm.uploadFiles();

          loader.hide();
        }
      },
      async uploadFiles() {
        let vm = this;
        let files = this.model.files;
        let promises = [];

        for (var section in files) {
          if (files.hasOwnProperty(section)) {

            for (var subSection in files[section]) {
              if (files[section].hasOwnProperty(subSection)) {

              let fileToUpload = files[section][subSection];
              if (fileToUpload instanceof File) {

                let formData = new FormData();
                formData.append('file', fileToUpload);
                formData.append('section', fileToUpload.section);
                formData.append('$section', section);
                if (fileToUpload.id) {
                  formData.append('id', fileToUpload.id);
                }

                let promise = FileUploadService.uploadAdditionalFiles({
                  userId: vm.loggedUser.id,
                  formData: formData
                }).then(function (response) {
                  let fdSection = formData.get('$section');
                  let fdSubSection = formData.get('$subSection');

                  files[fdSection][subSection] = {
                    id: response.data.id,
                    name: response.data.filename,
                    download: response.data.download
                  };

                }).catch(function (error) {
                  console.log('err', error);
                })

                promises.push(promise);
              }
            }
            }
          }
        }

        return await Promise.all(promises);
      },
      activateTab(ev)
      {
        this.active_tab_id = this.$refs['tab-sections'].activeTabId;
      },
      onShortDescriptionKeyUp(ev)
      {
        let vm = this;
        let value = vm.model.stage_two.short_description || '';
        let words = value.split(/\s/);

        if (words.length >= vm.maxWords)
        {
          if (ev.keyCode != 46 && ev.keyCode != 8)
          {
            ev.preventDefault();
            value = words.slice(0, vm.maxWords).join(' ') + ' ';
            vm.model.stage_two.short_description = value;
          }
        }

        vm.shortDescriptionWordsRemaining = Math.max(0, vm.maxWords - words.length);
      },
      changeApplicationStatus()
      {
        let vm = this;

        if (confirm('Are you sure you want to change application status?'))
        {
          DocumentService.updateApplicantStatus(vm.userId, {
            application_status: vm.model.application_status,
            stage_two_status: vm.model.stage_two_status
          }).then(function (response)
          {
          });
        }
      },
      changeRevisionStatus()
      {
        let vm = this;

        if (confirm('Are you sure you want to change revision status?'))
        {
          DocumentService.updateApplicantStatus(vm.userId, {
            application_status: vm.model.application_status,
            stage_two_status: vm.model.stage_two_status,
            revision_status: vm.model.revision.status
          }).then(function (response)
          {
          });
        }
      },
      addNewResultLine(model)
      {
        let vm = this;

        model = model || vm.model.stage_two;

        if (!model.results)
        {
          model.results = [];
        }

        model.results.push({
          activities: [
            {
              deliverables: [],
              indicators: [],
              verifications: []
            }
          ],
        });
      },
      addNewActivityLine(result)
      {
        if (result)
        {
          if (!result.activities)
          {
            result.activities = [];
          }

          result.activities.push({
            deliverables: [],
            indicators: [],
            verifications: []
          });
        }
      },
      addNewDeliverableLine(result)
      {
        if (result)
        {
          if (!result.deliverables)
          {
            result.deliverables = [];
          }

          result.deliverables.push('');
        }
      },
      addNewIndicatorLine(result)
      {
        if (result)
        {
          if (!result.indicators)
          {
            result.indicators = [];
          }

          result.indicators.push({
            title: '',
            objectives: {},
          });
        }
      },
      addNewVerificationLine(result)
      {
        if (result)
        {
          if (!result.verifications)
          {
            result.verifications = [];
          }

          result.verifications.push('');
        }
      },
      addOtherDocument(model)
      {
        model = model || this.model.stage_two;

        if (!model.other_documents)
        {
          model.other_documents = [];
        }

        model.other_documents.push({
          title: '',
        });
        this.$forceUpdate();
      },
      selectObjectives(indicator)
      {
        var vm = this;

        if (Array.isArray(indicator.objectives))
        {
          indicator.objectives = {};
        }

        vm.modalObjectives.indicator = indicator;
        vm.modalObjectives.visibility = true;
      },
      removeEntry(stack, index)
      {
        if (confirm('Are you sure you want to remove this entry'))
        {
          stack.splice(index, 1);
        }
      },
      mounted()
      {
        this.addOtherDocument();
        this.addOtherDocument(this.model.revision.data);
      },
      downloadAll()
      {
        let vm = this;
        DocumentService.getZipDoocuments(vm.userId).then(function (response)
        {
          window.open(response.data.url, '_blank');
          console.log(respons.data);
        });
      },
      async doExport(version)
      {
        const vm = this;
        const loader = vm.$loading.show();

        const response = await DocumentService.exportStageTwo({
          user_id: vm.userId,
          version: version
        }).catch((error) => {});

        loader.hide();

        if (response && response.data.success === true)
        {
          const pdf_url = response.data.pdf_url;
          const zip_url = response.data.zip_url;

          let html = vm.$t('full_proposal.notification__success_message') + '<br/><br/>' +
            '<a class="btn btn-primary mr-3" target="_blank" href="' + pdf_url + '">' + vm.$t('full_proposal.notification__download_pdf') + '</a>' +
            '<a class="btn btn-warning" target="_blank" href="' + zip_url + '">' + vm.$t('full_proposal.notification__download_zip') + '</a>';

          await swal({
            title: vm.$t('general.notification__success'),
            html: html,
            type: 'success',
            showConfirmButton: false,
            showCloseButton: true,
          });
        }
        else
        {
          let html = vm.$t('full_proposal.notification__error_message');

          await swal({
            title: vm.$t('general.notification__warning'),
            html: html,
            type: 'warning',
            showConfirmButton: true,
            showCloseButton: true,
          });
        }
      },
      submitApplication()
      {
        this.model.application_status = 'SUBMITTED';
      },
      submitStageTwo()
      {
        this.model.stage_two_status = 'SUBMITTED';
      },
      submitRevision()
      {
        this.model.revision.status = 'SUBMITTED';
      },
    },
    beforeMount() {
      let vm = this;
      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
    },
    async mounted() {
      let vm = this;
      await vm.getItems();

      let userDetails = vm.loggedUser;

      if (vm.loggedUser.role !== UserRoles.APPLICANT) {
        userDetails = vm.userDetails || vm.loggedUser;
      }

      let region = userDetails.region;

      if (region)
      {
        vm.referenceNr = ('2019-' + region.code + '-' + (userDetails.reference_id || userDetails.referenceId));
      }
      else
      {
        vm.referenceNr = '-'
      }

      vm.initialized = true;
    }
  };
</script>
<style lang="scss" scoped>
  .lang-input {
    width: 80%;
  }

  .flag-icon {
    font-size: 1.5rem;
  }

  .mail-sample-image {
    img {
      max-width: 80%;
    }
  }

  .card-reference
  {
    font-weight: 100;
    margin-bottom: 15px;
    // float: right;
  }

  a
  {
    cursor: pointer;
  }

  textarea {
    width: 100%;
    resize: both;
    max-height: none !important;
    height: 150px;

    &.subject, &.textarea-email {
      height: auto !important;
      width: 100%;
    }
  }

  .best-objectives-list
  {
      display: block;
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      padding: 0;
      counter-reset: objectives;

      li
      {
          display: flex;
          position: relative;
          align-items: center;
          counter-increment: objectives;
          min-height: 100px;
          box-sizing: border-box;
          border: 1px solid #ced3d7;
          padding: 15px 72px;
          margin-bottom: 12px;

          &:before
          {
              content: counter(objectives);
              display: block;
              width: 64px;
              height: 32px;
              text-align: center;
              line-height: 32px;
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              margin: auto 0;
              background-color: #173e95;
              color: #fff;
              font-weight: bold;
          }
      }

      &.is-editable li:before
      {
        display: none;
      }
  }

  .best-checkbox
  {
    .best-thumb
    {
        content: counter(objectives);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 20px;
        margin: auto 0;
        border: 2px solid #173e95;
        color: #fff;
        font-weight: bold;
        cursor: pointer;

        &:before
        {
          content: '';
          display: block;
          width: 90%;
          height: 90%;
          background-color: #173e95;
          visibility: hidden;
          opacity: 0;
          transition-property: visibility, opacity;
          transition-duration: .3s;
          transition-timing-function: ease-in-out;
        }
    }

    input[type="checkbox"]
    {
      display: none;
    }

    input[type="checkbox"]:checked ~ .best-thumb:before
    {
      visibility: visible;
      opacity: 1;
    }
  }

  .file-caption
  {
    margin-right: 10px;
    display: inline-block;
    // width: 45%;
  }

  .upload-file
  {
    display: inline-block;
    margin-bottom: -4px;
  }

  .file-form-group
  {
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
    min-height: 42px;

    &.file-highlighted
    {
      border-color: #296ef5;
      color: #296ef5;
    }
  }

  .card .card-body h4.card-title
  {
    font-weight: 600;
    margin-bottom: .95em;
  }

  table td
  {
    text-align: center;
    vertical-align: center;
    padding: 5px 10px;

    table td
    {
      text-align: left;
      border-top: none;
      border-left: none;
      border-right: none;

      input,
      textarea
      {
        width: 100%;
        height: 46px;
      }
    }

    a
    {
      display: block;
    }
  }

  .table-rio
  {
    table > tr:last-child > td
    {
      border: none;
    }
  }

  .logical-framework-table td
  {
    position: relative;
  }

  .remove-entry-btn
  {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  .card-title
  {
    display: inline-block;
    width: 49.5%;
    margin-bottom: 1.75rem !important;
  }

  .dropdown-menu a
  {
    display: block;
    width: 100%;
    padding: 10px 15px;
    cursor: pointer;
  }
</style>

<style lang="scss">
  .modal.show
  {
    align-items: normal;
  }

  .modal.show .modal-dialog
  {
    max-width: none !important;
  }
</style>
